import { Box, TextField, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getContactDetails } from "../../api/dataCapture";
import { setContactDetails } from "../../redux/reducers/dataCaptures";
import CustomTextField from "../../components/CustomTextField";
import './styles.css';
import { isEmpty } from "../../common/StaticExports";
import { useTranslation } from "react-i18next";

const ContactDetails = () => {
    const dispatch = useDispatch();
    const [t] = useTranslation();
    const clubDetails = useSelector((state:any) => state.clubDetails);
    const data = useSelector((state:any) => state.dataCaptures.contactDetails);
    const isAdmin = useSelector((state: any) => state.common.isAdmin);
    useEffect(() => {
        const fetchContactDetails = async () => {
            const response = await getContactDetails({clubId: clubDetails.id, isPast: false});
            dispatch(setContactDetails(response));
        }
        fetchContactDetails();
    }, []);
    
    const updateState = (key:any, updatedData:any) => {
        const updatedState = {...data, [key]: updatedData};
        dispatch(setContactDetails(updatedState));
    }

    return (
        <Box className='liceDataSubContainer'>
            <Typography className='standardsHeading uppercase'>contact person details</Typography>
            <Box  className={'licenceDataCDWrapper'}>
                <Box className={'licenceDataCDs'}>
                    <CustomTextField label={'Name'} value={data.name} manageChange={(value:any) => {updateState('name', value)}} errorMessage={t('REQUIRED')} isError={isEmpty(data.name) && !isAdmin} isDisabled={isAdmin} />
                    <CustomTextField label={'Department/Position'} value={data.department} manageChange={(value:any) => {updateState('department', value)}} errorMessage={t('REQUIRED')} isError={isEmpty(data.department) && !isAdmin} isDisabled={isAdmin} />
                    <CustomTextField label={'Telephone Number'} value={data.phone} manageChange={(value:any) => {updateState('phone', value)}} errorMessage={t('REQUIRED')} isError={isEmpty(data.phone) && !isAdmin} isDisabled={isAdmin} />
                    <CustomTextField label={'Fax'} value={data.fax} manageChange={(value:any) => {updateState('fax', value)}} errorMessage={t('REQUIRED')} isError={isEmpty(data.fax) && !isAdmin} isDisabled={isAdmin} />
                    <CustomTextField label={'Mobile Phone Number'} value={data.mobile} manageChange={(value:any) => {updateState('mobile', value)}} errorMessage={t('REQUIRED')} isError={isEmpty(data.mobile) && !isAdmin} isDisabled={isAdmin} />
                    <CustomTextField label={'Email Address'} value={data.email} manageChange={(value:any) => {updateState('email', value)}} errorMessage={t('REQUIRED')} isError={isEmpty(data.email) && !isAdmin} isDisabled={isAdmin} />
                    <CustomTextField label={'Work Location'} value={data.workLocation} manageChange={(value:any) => {updateState('workLocation', value)}} errorMessage={t('REQUIRED')} isError={isEmpty(data.workLocation) && !isAdmin} isDisabled={isAdmin} />
                </Box>
            </Box>
        </Box>
    )
}

export default ContactDetails;